<template lang="pug">
    div
        Select(@on-change="selectExample")
            Option(
                v-for="(role, index) in examples" 
                :value="index" 
                :label="role.roleName"
                :key="index" 
            )
</template>

<script>
export default {
    name: "RolesManageFormExamples",
    components: {},
    data() {
        return {
            permissionCategory: [
                {
                    key: "dashboardPermission",
                    name: "Dashboards"
                },
                {
                    key: "domainManagePermission",
                    name: "Domains"
                },
                {
                    key: "groupResourcesPermission",
                    name: "GroupResource"
                },
                {
                    key: "intelligentProtectionPermission",
                    name: "IntelligentProtection",
                },
                {
                    key: "billingPermission",
                    name: "Billing"
                }
            ],
            examples: [],
            groupRolePermission: [
                {
                    roleName: "group_viewer",
                    dashboardPermission: {
                        read: true,
                        write: false
                    },
                    domainManagePermission: {
                        read: true,
                        write: false
                    },
                    groupResourcesPermission: {
                        read: true,
                        write: false
                    },
                    intelligentProtectionPermission: {
                        read: false,
                        write: false
                    },
                    billingPermission: {
                        read: true,
                        write: false
                    }
                },
                {
                    roleName: "group_admin",
                    dashboardPermission: {
                        read: true,
                        write: true
                    },
                    domainManagePermission: {
                        read: true,
                        write: true
                    },
                    groupResourcesPermission: {
                        read: true,
                        write: true
                    },
                    intelligentProtectionPermission: {
                        read: false,
                        write: false
                    },
                    billingPermission: {
                        read: true,
                        write: true
                    }
                },
                {
                    roleName: "team_lead",
                    dashboardPermission: {
                        read: true,
                        write: false
                    },
                    domainManagePermission: {
                        read: true,
                        write: true
                    },
                    groupResourcesPermission: {
                        read: false,
                        write: false
                    },
                    intelligentProtectionPermission: {
                        read: false,
                        write: false
                    },
                    billingPermission: {
                        read: false,
                        write: false
                    }
                },
                {
                    roleName: "operator",
                    dashboardPermission: {
                        read: true,
                        write: false
                    },
                    domainManagePermission: {
                        read: true,
                        write: true
                    },
                    groupResourcesPermission: {
                        read: false,
                        write: false
                    },
                    intelligentProtectionPermission: {
                        read: false,
                        write: false
                    },
                    billingPermission: {
                        read: false,
                        write: false
                    }
                },
                {
                    roleName: "client",
                    dashboardPermission: {
                        read: true,
                        write: false
                    },
                    domainManagePermission: {
                        read: false,
                        write: false
                    },
                    groupResourcesPermission: {
                        read: false,
                        write: false
                    },
                    intelligentProtectionPermission: {
                        read: false,
                        write: false
                    },
                    billingPermission: {
                        read: false,
                        write: false
                    }
                }
            ]
        };
    },
    props: {},
    watch: {},
    created() {
        this.setRolePermission();
        this.setRoleExample();
    },
    mounted() {},
    methods: {
        selectExample(index) {
            this.$emit("selectExample", this.examples[index]);
        },
        getOtherPermissions(item, value) {
            switch (item.showName) {
                case "CertsUpload":
                    return { downloadSystemCerts: value };
                default:
                    return {};
            }
        },
        setRoleExample() {
            let allItems = this.$store.getters.getMenuItems.map(item => item.subItems).flat();

            this.examples = this.groupRolePermission.map(roleExample => {
                var rolePermission = {};
                this.permissionCategory.map(permission => {
                    rolePermission.roleName = roleExample.roleName;
                    const currentRoleExamplePerm = roleExample[permission.key] || { read: false, write: false };    
                    rolePermission[permission.key] = {
                        name: permission.name,
                        read: currentRoleExamplePerm.read,
                        write: currentRoleExamplePerm.write,
                        _showChildren: true,
                        children: []
                    };
                    allItems.map(item => {
                        if (item.requiredPermission == permission.key) {
                            rolePermission[permission.key].children.push({
                                name: item.showName,
                                read: currentRoleExamplePerm.read,
                                write: currentRoleExamplePerm.write,
                                other: this.getOtherPermissions(item, currentRoleExamplePerm.read),
                            });
                        }
                    });
                });

                return rolePermission;
            });
        },
        setRolePermission() {
            let newRolePermission = [];
            // 將後台配置格式轉成前台所需
            this.$store.state.platformPlan.multiTenancyConfigs.rolePermissionExample.forEach((roleItem) => {
                let backendExample = {};
                backendExample.roleName = roleItem.name;
                roleItem.data.forEach((dataItem) => {
                    backendExample[dataItem.value] = {
                        read: dataItem.read,
                        write: dataItem.write,
                    };
                });
                newRolePermission.push(backendExample);
            });

            // 把預設的跟新的role concat一起
            let totalRolePermission = this.groupRolePermission.concat(newRolePermission);

            // 重複的就用 Object.assign
            let newTotalRolePermission = totalRolePermission.reduce((arr, item) => {
                if (arr[item.roleName]) {
                    arr[item.roleName] = Object.assign({}, arr[item.roleName], item);
                } else arr[item.roleName] = item;
                return arr;
            }, {});
            let lastRolePermission = Object.values(newTotalRolePermission);
            this.groupRolePermission = lastRolePermission;
        },
    },
    computed: {},
    beforeDestroy() {}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/RolesManage/FormExamples.vue